import { ActiveRecord, BaseFieldWidget, ModelFieldType, SPI, ViewType, Widget } from '@kunlun/dependencies';
import Comp from './ActivityPlanTableFieldWidget.vue';
import { FormM2MTableDraftWidget } from '../FormM2MTableDraft';

@SPI.ClassFactory(
  BaseFieldWidget.Token({
    model: [
      'deli.platform.promotion.DeliAriesPlatformPromotionPlan',
      'deli.platform.promotion.DeliAriesPlatformPromotionReginPlan',
      'deli.aries.seller.DeliAriesSellerPromotionPlan'
    ],
    viewName: ['品牌推广方案表单_FORM_uiViewf42a22827c5340a3b37fd6fd554f115e', '区域推广方案表单_FORM_uiView1b7fb5010311402a97b1a086862f8c8d'],
    name: 'itemDetail',
    widget: 'Table',
    viewType: ViewType.Form,
    ttype: ModelFieldType.ManyToMany
  })
)
export class ActivityPlanTableFieldWidget extends FormM2MTableDraftWidget {
  public initialize(props: any) {
    super.initialize(props);
    this.setComponent(Comp);

    return this;
  }

  @Widget.Reactive()
  get _dataSource() {
    return this.value;
  }

  @Widget.Reactive()
  get rModel() {
    // 表格模型
    return this.runtimeSubviewContext.model;
  }

  @Widget.Reactive()
  mountedFlag = false;

  protected mountedProcess(): Promise<void> {
    this.mountedFlag = true;
    return super.mountedProcess();
  }

  // FIXME: 全量更细性能不可接受
  // 更新商品清单表格
  @Widget.Method()
  updateMerchBill() {
    const billMap = new Map();
    for (let item of this.value!) {
      const { merchBillName } = item;
      if (!merchBillName) continue;

      if (billMap.has(merchBillName)) {
        billMap.set(merchBillName, billMap.get(merchBillName) + 1);
      } else {
        billMap.set(merchBillName, 1);
      }
    }
    const newBill = Array.from(billMap, ([key, value]) => ({ merchBillName: key, itemNum: value }));
    if (!newBill.length) {
      (this.formData.merchBill as any[]).splice(0, (this.formData.merchBill as any).length);
    } else {
      (this.formData.merchBill as any[]).splice(0, (this.formData.merchBill as any).length);
      Object.assign(this.formData.merchBill!, JSON.parse(JSON.stringify(newBill)));
    }
  }

  @Widget.Method()
  addDataSource(data: any[]) {
    const newVal = [...this.value!, ...data];
    this.setValue(JSON.parse(JSON.stringify(newVal)));
    this.updateMerchBill();
  }

  @Widget.Method()
  delDataSource(data: any[], delAll?: boolean) {
    let newVal: ActiveRecord[] = [];
    if (!delAll) {
      const rowIds = data.map((item) => item._X_ROW_KEY);
      newVal = this.value!.filter((item) => !rowIds.includes(item._X_ROW_KEY));
    }
    this.setValue(JSON.parse(JSON.stringify(newVal)));
    this.updateMerchBill();
  }
}
